module.exports = __webpack_public_path__ + "img/index.6abefd45.gif";